@defer (when renderedHtml()) {
  <div class="preview-container">
    <!-- Device Toggle Row (hidden on mobile) -->
    @if (!isMobile()) {
      <div class="device-toggle-row">
        <mat-button-toggle-group [value]="selectedDevice()" (valueChange)="previewSizeClicked($event)">
          <mat-button-toggle value="desktop" data-testid="email-ui-builder-v3-preview-device-desktop">
            <mat-icon>computer</mat-icon>
            {{ 'CONTENT_BUILDER.PREVIEW.DEVICE_DESKTOP' | translate }}
          </mat-button-toggle>
          <mat-button-toggle value="tablet" data-testid="email-ui-builder-v3-preview-device-tablet">
            <mat-icon>tablet_mac</mat-icon>
            {{ 'CONTENT_BUILDER.PREVIEW.DEVICE_TABLET' | translate }}
          </mat-button-toggle>
          <mat-button-toggle value="mobile" data-testid="email-ui-builder-v3-preview-device-mobile">
            <mat-icon>phone_iphone</mat-icon>
            {{ 'CONTENT_BUILDER.PREVIEW.DEVICE_MOBILE' | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }

    <!-- Preview Info Row -->
    <div class="preview-info-row">
      <div class="preview-info-left">
        @if (hasContactProvider()) {
          <span class="preview-label">{{ 'CONTENT_BUILDER.PREVIEW.PREVIEWING_AS' | translate }}</span>
          <span
            class="contact-name"
            (click)="onSelectContactClick()"
            data-testid="email-ui-builder-v3-preview-contact-selector"
          >
            {{ selectedContact()?.name ?? 'CONTENT_BUILDER.PREVIEW.SELECT_CONTACT' | translate }}
          </span>
        }
      </div>
      @if (showActions()) {
        <div class="preview-info-right">
          @if (hasContactProvider() && showSendPreview) {
            <button
              mat-stroked-button
              (click)="onSendPreviewClick()"
              [disabled]="previewDisabled()"
              data-testid="email-ui-builder-v3-preview-send-preview"
              disabledInteractive
              [matTooltip]="'CONTENT_BUILDER.PREVIEW.SEND_PREVIEW_DISABLED' | translate"
              [matTooltipDisabled]="!previewDisabled()"
            >
              {{ 'CONTENT_BUILDER.PREVIEW.SEND_PREVIEW_BUTTON' | translate }}
            </button>
          }
          <button
            mat-flat-button
            color="primary"
            [disabled]="saveDisabled()"
            data-testid="email-ui-builder-v3-preview-save"
            disabledInteractive
            [matTooltip]="'CONTENT_BUILDER.PREVIEW.SAVE_DISABLED' | translate"
            [matTooltipDisabled]="!saveDisabled()"
            (click)="onSaveClick()"
          >
            {{ 'CONTENT_BUILDER.PREVIEW.SAVE_BUTTON' | translate }}
          </button>
        </div>
      }
    </div>

    <!-- Preview Content Area -->
    <div class="preview-content">
      @if (renderedHtml()) {
        <div class="preview-iframe-container">
          <div class="preview-email-wrapper" [style.max-width]="emailPreviewWidth()">
            <email-builder-inbox-preview
              [subject]="subject()"
              [previewText]="previewText()"
              [senderName]="senderName()"
              [isMobilePreview]="isMobilePreview()"
            />
            <iframe
              #iframePreview
              data-testid="email-ui-builder-v3-preview-iframe"
              [style.min-height]="isMobile() ? '100vh' : null"
              sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
              class="email-preview-iframe"
              [srcdoc]="isMobile() && renderedHtml() ? (renderedHtml() | iTrustThisHtml) : null"
              (load)="setIframeHeightOnMobile()"
            ></iframe>
          </div>
          <div class="iframe-resize-protector"></div>
        </div>
      } @else {
        <div class="empty-state">
          <p class="empty-state-text">{{ 'CONTENT_BUILDER.PREVIEW.EMPTY_STATE' | translate }}</p>
        </div>
      }
    </div>
  </div>
} @loading {
  <glxy-loading-spinner></glxy-loading-spinner>
}
